import CircleType from 'circletype';

export default class PageHeaderTitle {
    constructor($el) {
        this.$el = $el;
        this.first = this.$el.querySelector('[data-page-header-title-first]')
        this.second = this.$el.querySelector('[data-page-header-title-second]')

        this.firstCurve = this.firstCurve.bind(this);
        this.secondCurve = this.secondCurve.bind(this);

        this.firstCurve();
        if(this.second) {
            this.secondCurve();
        }
    }

    firstCurve() {
        const circleType = new CircleType(this.first);
        circleType.radius(900);
    }

    secondCurve() {
        const circleTypeSecond = new CircleType(this.second);
        circleTypeSecond.radius(700);
    }
}